<template>
  <div class="flex flex-col">
    <div class="mt-24 md:mt-28 md:mb-16 my-0 max-w-3xl m-auto">
      <h1 class="self-center text-center uppercase md:px-7 text-4xl md:text-5xl">Регистрация прошла успешно!</h1>
      <p class="mt-6 text-center mb-5 px-5 text-sm md:text-base tracking-wide">
        Благодарим за предоставленные данные. Будем рады помочь Вам. VIP-сервис Дирекции скоростного сообщения
        8-800-775-44-33
      </p>
    </div>
    <div class="mt-20 train overflow-hidden relative">
      <img src="../assets/images/train-mobile.png" alt="Train" class="h-auto md:hidden" />
      <img src="../assets/images/train.png" alt="Train" class="h-auto hidden md:block" />
    </div>
  </div>
</template>

<style scoped>
h1,
p {
  background: linear-gradient(180deg, #fff 0%, #787878 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
